import React, { FC } from 'react'
import './NewsTarget.scss'
import { IoTimeOutline } from "react-icons/io5";
import moment from 'moment';
import useWindowWidth from 'app_hooks/useWindowWidth';

interface INewsTarget {
  title: string
  image: string
  date: string
  topic?: string
}

const MOVIL_BREAKPOINT = 760

const NewsTarget: FC<INewsTarget> = ({image, title, date, topic}) => {
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= 760

  const formatDate = moment(date).format('DD/MM/YYYY');

  return (
    <div className='news-target--container'>
      <div className='news-target--image-container'>
        <img className='news-target--image' src={image} alt={`Imagen de ${title}`} />
      </div>
      <div>
        {isMovil && (
          <div className='news-target--title'>{title}</div>
        )}
        <div className='news-target--date-container'>
            <p className='news-target--date'><IoTimeOutline className='news-target--icon'/>{formatDate}</p>
            {!!topic && (
              <p className='news-target--topic'>{topic}</p>
            )}
        </div>
        {!isMovil && (
          <div className='news-target--title'>{title}</div>
        )}
      </div>
    </div>
  )
}

export default NewsTarget


